import { getUsdtContract, getRadContract, getAccountAddress } from "../index";
import { STAKE_ADDRESS, LOTTERY_ADDRESS } from "../constants";
import { sendContractMethod } from "./txHelper";

const MAX_UINT256 =
  "115792089237316195423570985008687907853269984665640564039457584007913129639935";

async function getAllowance(tokenContract, owner, spender) {
  return tokenContract.methods.allowance(owner, spender).call();
}

async function approveToken(tokenContract, spender, amount) {
  const method = tokenContract.methods.approve(spender, amount);
  return sendContractMethod(method);
}

export async function ensureUsdtAllowanceForStake(amountWei) {
  const owner = getAccountAddress();
  const token = getUsdtContract();
  const allowance = await getAllowance(token, owner, STAKE_ADDRESS);
  if (BigInt(allowance) >= BigInt(amountWei)) {
    return null;
  }
  return approveToken(token, STAKE_ADDRESS, MAX_UINT256);
}

export async function ensureRadAllowanceForLottery(amountWei) {
  const owner = getAccountAddress();
  const token = getRadContract();
  const allowance = await getAllowance(token, owner, LOTTERY_ADDRESS);
  console.log(allowance,'allowance');
  if (BigInt(allowance) >= BigInt(amountWei)) {
    return null;
  }
  return approveToken(token, LOTTERY_ADDRESS, MAX_UINT256);
}

export async function getUsdtBalance(address) {
  const token = getUsdtContract();
  return token.methods.balanceOf(address).call();
}

export async function getRadBalance(address) {
  const token = getRadContract();
  return token.methods.balanceOf(address).call();
}
